import { render, staticRenderFns } from "./goodsNormallPay.vue?vue&type=template&id=a8f4373a&"
import script from "./goodsNormallPay.vue?vue&type=script&lang=js&"
export * from "./goodsNormallPay.vue?vue&type=script&lang=js&"
import style0 from "./goodsNormallPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports